import { PaymentType } from '../economy/case-vouchers/index.js';
export var Provider;
(function (Provider) {
    Provider["Frisbii"] = "frisbii";
    Provider["MobilePeople"] = "mobile-people";
    Provider["FarPay"] = "farpay";
})(Provider || (Provider = {}));
export var PaymentMethodStatus;
(function (PaymentMethodStatus) {
    PaymentMethodStatus["CREATED"] = "CREATED";
    PaymentMethodStatus["SAVED"] = "SAVED";
    PaymentMethodStatus["DELETED"] = "DELETED";
})(PaymentMethodStatus || (PaymentMethodStatus = {}));
export var PendingPaymentStatus;
(function (PendingPaymentStatus) {
    PendingPaymentStatus["PENDING"] = "PENDING";
    PendingPaymentStatus["APPROVED"] = "APPROVED";
    PendingPaymentStatus["REJECTED"] = "REJECTED";
})(PendingPaymentStatus || (PendingPaymentStatus = {}));
export var FarpayPaymentTypes;
(function (FarpayPaymentTypes) {
    FarpayPaymentTypes["BETALINGSSERVICE"] = "BS";
    FarpayPaymentTypes["LEVERANDORSERVICE"] = "LS";
    FarpayPaymentTypes["DANKORT"] = "Dankort";
    FarpayPaymentTypes["VISA"] = "Visa";
    FarpayPaymentTypes["MASTERCARD"] = "MasterCard";
    FarpayPaymentTypes["MOBILEPAYSUBSCRIPTION"] = "MobilePaySubscriptions";
    FarpayPaymentTypes["MOBILEPAYINVOICE"] = "MobilePayInvoice";
})(FarpayPaymentTypes || (FarpayPaymentTypes = {}));
export var MobilePeoplePaymentTypes;
(function (MobilePeoplePaymentTypes) {
    MobilePeoplePaymentTypes["VISA"] = "Visa";
    MobilePeoplePaymentTypes["MASTERCARD"] = "MasterCard";
    MobilePeoplePaymentTypes["MOBILEPAY"] = "MobilePay";
    MobilePeoplePaymentTypes["DANKORT"] = "Dankort";
    MobilePeoplePaymentTypes["BETALINGSSERVICE"] = "BS";
    MobilePeoplePaymentTypes["LEVERANDORSERVICE"] = "LS";
})(MobilePeoplePaymentTypes || (MobilePeoplePaymentTypes = {}));
export const providerPaymentTypeToPaymentType = (provider, paymentType) => {
    switch (provider) {
        case Provider.FarPay:
            switch (paymentType) {
                case FarpayPaymentTypes.BETALINGSSERVICE:
                    return PaymentType.Betalingsservice;
                case FarpayPaymentTypes.LEVERANDORSERVICE:
                    return PaymentType.Leverandørservice;
                case FarpayPaymentTypes.DANKORT:
                    return PaymentType.Dankort;
                case FarpayPaymentTypes.VISA:
                    return PaymentType.Visa;
                case FarpayPaymentTypes.MASTERCARD:
                    return PaymentType.Mastercard;
                case FarpayPaymentTypes.MOBILEPAYSUBSCRIPTION:
                case FarpayPaymentTypes.MOBILEPAYINVOICE:
                    return PaymentType.MobilePay;
                default:
                    return undefined;
            }
        case Provider.MobilePeople:
            switch (paymentType) {
                case MobilePeoplePaymentTypes.BETALINGSSERVICE:
                    return PaymentType.Betalingsservice;
                case MobilePeoplePaymentTypes.LEVERANDORSERVICE:
                    return PaymentType.Leverandørservice;
                case MobilePeoplePaymentTypes.DANKORT:
                    return PaymentType.Dankort;
                case MobilePeoplePaymentTypes.VISA:
                    return PaymentType.Visa;
                case MobilePeoplePaymentTypes.MASTERCARD:
                    return PaymentType.Mastercard;
                case MobilePeoplePaymentTypes.MOBILEPAY:
                    return PaymentType.MobilePay;
                default:
                    return undefined;
            }
        default:
            return undefined;
    }
};
//# sourceMappingURL=index.js.map